module.exports = __webpack_public_path__ + "img/bus.1dd110bd.svg";